module.exports = __webpack_public_path__ + "static/img/loadingImg.616a7805.gif";